module.exports = __webpack_public_path__ + "static/media/invoice-tracking.e61c506f.svg";